import axios from 'axios';
import { storeJWTToken, removeJWTToken } from '@/services/auth';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

instance.interceptors.response.use(response => {
  return Promise.resolve(response.data || response);
});

instance.setAuthenticationToken = token => {
  if (token) {
    instance.defaults.headers.common.Authorization = 'Bearer ' + token;
    storeJWTToken(token);
  } else {
    delete instance.defaults.headers.common.Authorization;
    removeJWTToken();
  }
};

export default instance;
